export const practiceQuestions = {
    "data": {
        "count": 1,
        "next": null,
        "previous": null,
        "results": [
            {
                "id": 1,
                "question_detail": {
                    "id": 1,
                    "topic_name": "Sample question for you to check your connection, audio and video quality",
                    "rank": 1,
                    "question": "Say something about yourself and your work experience. You have One minute.",
                    "time_to_answer": 1,
                    "created": "2022-08-09T07:53:20.595237Z",
                    "updated": "2022-08-09T07:53:20.595255Z",
                    "is_deleted": false,
                    "topic": 1,
                    "created_by": 1
                },
                "created": "2022-08-09T07:53:20.602644Z",
                "updated": "2022-08-09T07:53:20.602660Z",
                "is_deleted": false,
                "interview_kit": 1,
                "question": 1
            }
        ]
    }
}
